<template>
    <kt-panel>
        <form @submit.prevent="submitRequestCustomer($event, query)"
              id="single-request-form-customer"
              class="kt-form p-3 my-4"
        >
            <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('online-factor.label_create_customer') }}
                    </div>
                    <kt-row class="p-2">
                        <kt-col  lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="status">
                                    {{ $t('online-factor.customer_type') }}
                                  <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-select
                                    v-model="query.customer_type"
                                >
                                    <option
                                        value="1"
                                    >
                                        {{ $t('online-factor.legal') }}
                                    </option>
                                    <option
                                        value="2"
                                    >
                                        {{ $t('online-factor.real') }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="legal_business_name">
                                    {{ $t('online-factor.legal_business_name') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="legal_business_name" name="legal_business_name" v-model="query.legal_business_name"
                                                 :disabled="query.customer_type =='2'">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="real_first_name" >
                                    {{ $t('online-factor.real_first_name') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="real_first_name" name="real_first_name" v-model="query.real_first_name"
                                                 :disabled="query.customer_type =='1'">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="real_last_name">
                                    {{ $t('online-factor.real_last_name') }}
                                    <!-- <span class="text-danger h5 pb-3">*</span> -->
                                </kt-form-label>
                                <kt-form-control id="real_last_name" name="real_last_name" v-model="query.real_last_name"
                                                 :disabled="query.customer_type =='1'">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>

                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="mobile">
                                    {{ $t('online-factor.mobile') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="mobile" name="mobile" v-model="query.mobile">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="email">
                                    {{ $t('online-factor.email') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="email" name="email" v-model="query.email">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <p class="badge badge-danger"> در صورت انتخاب فیلد تلفن همراه فیلد ایمیل اختیاری خواهد بود</p>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="phone">
                                    {{ $t('online-factor.phone') }}
                                </kt-form-label>
                                <kt-form-control id="phone" name="phone" v-model="query.phone">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                          <kt-form-group>
                            <kt-form-label for="province">
                              {{ $t('label.province') }}
                            </kt-form-label>
                            <select
                                id="province"
                                name="province"
                                v-model="query.province"
                                class="form-control kt-selectpicker"
                                @change="loadCities(false)"
                            >
                              <option
                                  v-bind:key="province.key"
                                  v-for="province in provinces"
                                  :value="province.id"
                              >
                                {{ province.value }}
                              </option>
                            </select>
                          </kt-form-group>
                        </kt-col>
                      <kt-col lg="6" md="6" xs="12">
                          <kt-form-group>
                              <kt-form-label for="city">
                                  {{ $t('label.city') }}
                              </kt-form-label>
                              <div id="city_select_holder">
                                  <select
                                      id="city_customer"
                                      name="city_customer"
                                      class="form-control"
                                      v-model="query.city"
                                  >
                                  </select>
                              </div>
                          </kt-form-group>
                      </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="national_code">
                                    {{ $t('online-factor.national_code') }}
                                </kt-form-label>
                                <kt-form-control id="national_code" name="national_code" v-model="query.national_code">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="address">
                                    {{ $t('online-factor.address') }}
                                </kt-form-label>
                                <kt-form-control id="address" name="address" v-model="query.address">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="postal_code">
                                    {{ $t('online-factor.postal_code') }}
                                </kt-form-label>
                                <kt-form-control id="postal_code" name="postal_code" v-model="query.postal_code">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="file">
                                    <kt-icon type="fa" name="paperclip"></kt-icon>
                                    {{ $t('online-factor.image') }}
                                    <!-- <span class="text-danger h5 pb-3">*</span> -->
                                </kt-form-label>
                                <kt-form-control
                                    @change="processFile"
                                    type="file"
                                    class="custom-file-upload"
                                    name="file"
                                    id="file"
                                    accept=".jpg"/>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-end" v-if="query.file">
                            <img :src="picPreview" class="w-25" />
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-end" v-else>
                            <img id="none"  class="w-25" src="/assets/media/none-item-picture.jpg">
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-button
                                id="form-btn"
                                class="btn btn-success btn-wide text-center py-2"
                                type="submit"
                                variant="success"
                            >
                                {{ $t('money_request.submit') }}
                            </kt-button>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                           
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>
    </kt-panel>
</template>

<script>

import $ from "jquery";
import toastr from "toastr";
import { KTApp } from '@/plugins/core/app'
import { provinces, fullCities } from '@/constants/provinceCities'
import { i18n } from '@/plugins/i18n';
import {onlineFactorService} from "@/common/api.service";


export default {
    props: {
        submitSingleRequest: {
            default: function($event, query) {},
            type: Function
        },
    },
    data() {
        return {
          provinces: provinces,
            query: {
                is_unlimited: false,
                customer_type : '',
                file : false,
                city: ''
            },
            picPreview:"",
            allCity:[]
        }
    },
    computed : {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        }
    },
    mounted() {
        this.loadCities(true);
    },
    methods: {
        loadCities(load_city) {
          let province = $('#province')

            let city_select_holder = document.getElementById('city_select_holder');
            city_select_holder.innerHTML = ''
            let cities_element = document.createElement("select");
            cities_element.id = 'city';
            cities_element.name = 'city';
            cities_element.className = 'form-control';


            cities_element.onchange = function(){
                this.query.city = $('#city').val()
            }.bind(this);

            city_select_holder.appendChild(cities_element)

              let province_val = province.find(":selected").val()

              let m_cities = Object.entries(fullCities)
              let cities

          m_cities.forEach(function (item) {
            if (item[0] == province_val) {
                cities = item[1]
            }
          })

          this.allCity = cities

          for(let x in this.allCity){
              let option = document.createElement("option")
              option.text = this.allCity[x];
              option.value = this.allCity[x];
              cities_element.appendChild(option)
          }

            if (load_city)
                $('#city_customer').val(this.query.city)

                this.query.city = this.allCity[0]



            $('#city_customer').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })


            $('#city_customer').selectpicker({
            size: 6,
            liveSearch: true,
            noneResultsText: i18n.t('selectpicker.none_result'),
            selectAllText: i18n.t('selectpicker.select_all'),
            noneSelectedText: i18n.t('selectpicker.nothing_selected')
          })
        },
        processFile(e) {
           this.query.file = e.target.files[0]
            this.picPreview = URL.createObjectURL(e.target.files[0]);
        },
        submitRequestCustomer(e, query) {
            let form = $('#single-request-form-customer')
            let btn = $('#form-btn')

            if (query.customer_type) {

              form.validate( {
                rules: {
                  customer_type: {
                    required: true
                  },
                  mobile: {
                    required: query.email ? false : true,
                  },
                  email: {
                    required: query.mobile ? false : true,
                  },
                 image: {
                    required: true,
                 },
                  legal_business_name :{
                        required: query.customer_type === '1' ? true : false
                  },
                  real_first_name :{
                        required:query.customer_type === '2' ? true : false
                  },
                  real_last_name :{
                        required:query.customer_type === '2' ? false : true
                  }
                }
              })
              if (!form.valid())
                return;

            } else  {
                this.toastr.error(i18n.t('online-factor.none_customer_type'))
                return;
            }

            KTApp.progress(btn)


            let data = {
                customer_type : query.customer_type,
                real_first_name: query.real_first_name ? query.real_first_name : null,
                real_last_name: query.real_last_name ? query.real_last_name : "",
                legal_business_name: query.legal_business_name ? query.legal_business_name : null,
                email: query.email ? query.email : "",
                mobile: query.mobile ? query.mobile : "",
                address: query.address ? query.address :  "",
                city: query.city ? query.city :  "",
                province: query.province ? query.province :  null,
                image: query.file ? query.file : ""
            }
            if (query.postal_code) {
                data = {...data, postal_code:query.postal_code}
            }
            if (query.national_code) {
                data = {...data, national_code:query.national_code}
            }
            if (query.phone) {
                data = {...data, phone:query.phone}
            }


            KTApp.progress(btn)

            let isAdmin = this.$can('change-setting', 'payment-link')
            let action = isAdmin ? onlineFactorService.adminCreateCustomer : onlineFactorService.createCustomer
            action(data)
                .then(response => {
                    this.toastr.success(response.data.message)
                    this.$router.push('/customers')
                })
                .catch(({response}) => {
                    this.toastr.error(response.data.message)
                    for(let err in response.data.data){
                        this.toastr.error(response.data.data[err][0])
                    }
                }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>
<style scoped>

.preview_img {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 10px;
    left: 80px;
}
</style>